export default "__VITE_ASSET__BYStoKJ0__"